import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTION_DOCTOR_EMERGENCY_SCHEDULE } from "../../action-types/actions";
import {
  getLocalizedMessage,
  getLocalizedErrorMessage,
} from "../../utils/messageHelper";
import i18n from "../../i18n";

export const updateDoctorEmergencySchedule = createAsyncThunk(
  ACTION_DOCTOR_EMERGENCY_SCHEDULE.update_doctor_midnight_schedule,
  async (data, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.put(
        `${process.env.REACT_APP_API_URL}${APP_PATH.updateDoctorEmergencySchedule}`,
        data,
      );

      if (response?.data?.status === true || response?.status === 200) {
        const message = getLocalizedMessage(response, i18n);
        toast.success(message);
        return response.data;
      } else {
        const message = getLocalizedErrorMessage({ response }, i18n);
        toast.error(message);
        return rejectWithValue(response.data);
      }
    } catch (error) {
      console.error("Error updating emergency schedule:", error);
      const message = getLocalizedErrorMessage(error, i18n);
      toast.error(message);
      return rejectWithValue(error.response?.data || message);
    }
  },
);
